export default "/images/18bf7e85b1e8b8800d2dad3a28b12977.avif";